var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashedLineRx10 = function SvgDashedLineRx10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 195,
    x: 0.5,
    y: 0.5,
    stroke: "#7A7359",
    strokeDasharray: "4 4",
    rx: 10
  })));
};
export { SvgDashedLineRx10 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTk2IiBoZWlnaHQ9IjE5NiIgZmlsbD0ibm9uZSI+PHJlY3QgeD0iLjUiIHk9Ii41IiB3aWR0aD0iMTk1IiBoZWlnaHQ9IjE5NSIgcng9IjEwIiBzdHJva2U9IiM3QTczNTkiIHN0cm9rZS1kYXNoYXJyYXk9IjQgNCIvPjwvc3ZnPg==";